import { useState } from "react";

import { useEditMode } from "../use-edit-mode";
import { storePageApi } from "../store-page/client";

/** The coworld's icon: one square image, shown in the page header and the one-pager. */
export function IconField() {
  const { slug, editor } = useEditMode();
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const icon = editor.content.icon ?? null;

  async function upload(file: File) {
    setError(null);
    const bitmap = await createImageBitmap(file).catch(() => null);

    if (!bitmap) return setError("That file could not be read as an image.");

    const { width, height } = bitmap;
    bitmap.close();

    if (Math.abs(width - height) > 2)
      return setError(
        `The icon must be square; this one is ${width}x${height}.`,
      );

    if (width < 256)
      return setError(
        `The icon must be at least 256 px; this one is ${width} px.`,
      );

    setUploading(true);
    void storePageApi
      .uploadImage({ slug, file })
      .then(
        (uploaded) => editor.updateContent({ icon: uploaded.full }),
        (e: unknown) => setError(e instanceof Error ? e.message : String(e)),
      )
      .finally(() => setUploading(false));
  }

  return (
    <div>
      <label>
        Icon (square image, at least 256 px)
        <input
          type="file"
          accept="image/*"
          disabled={!editor.loaded || editor.mutating || uploading}
          onChange={(e) => {
            const file = e.target.files?.[0];

            if (file) void upload(file);

            e.target.value = "";
          }}
        />
      </label>
      {icon ? <img src={icon} alt="" width={48} height={48} /> : null}
      {icon ? (
        <button
          type="button"
          onClick={() => editor.updateContent({ icon: null })}
        >
          Remove icon
        </button>
      ) : null}
      {error ? <p role="alert">{error}</p> : null}
    </div>
  );
}
